import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00cf5ea4")

_pushScopeId("data-v-00cf5ea4")
const _hoisted_1 = { class: "pt-4" }
const _hoisted_2 = { class: "flex flex-row justify-between" }
const _hoisted_3 = { class: "flex flex-row w-3/4" }
const _hoisted_4 = { class: "pt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Search, {
          placeholder: _ctx.$t('urgentDeliveryManagement.searchPlaceholder'),
          value: _ctx.parameters.search,
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          class: "w-300px"
        }, null, 8, ["placeholder", "value", "onInput", "onClear"]),
        _createVNode(_component_lp_button, {
          id: "btnSort",
          title: _ctx.$t('urgentDeliveryManagement.sortLatest'),
          icon: "sort-filter",
          textColor: _ctx.sortButtonStyle.textColor,
          customClass: _ctx.sortButtonStyle.customClass,
          color: _ctx.sortButtonStyle.color,
          outline: "",
          small: "",
          onClick: _ctx.onSort,
          class: "w-300px"
        }, null, 8, ["title", "textColor", "customClass", "color", "onClick"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      (_ctx.listData.data.length)
        ? (_openBlock(), _createBlock(_component_TableV2, {
            key: 0,
            pagination: _ctx.listData.pagination,
            "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listData.pagination = $event)),
            loading: _ctx.apiListData.loading,
            columns: _ctx.columns,
            data: _ctx.listData.data,
            paginationStyle: "v3",
            pinnedSubstractHeight: "300px",
            isDetailAble: "",
            onClick: _ctx.goDetail,
            onRequest: _ctx.fetchList,
            onTryAgain: _ctx.fetchList,
            errorCause: _ctx.apiListData.errorType,
            customButtonAction: _ctx.customButton
          }, null, 8, ["pagination", "loading", "columns", "data", "onClick", "onRequest", "onTryAgain", "errorCause", "customButtonAction"]))
        : _createCommentVNode("", true),
      (!_ctx.listData.data.length)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            customHeaderMessage: _ctx.emptyStateData.headerMessage,
            customMessage: _ctx.emptyStateData.message,
            icon: _ctx.emptyStateData.icon
          }, null, 8, ["customHeaderMessage", "customMessage", "icon"]))
        : _createCommentVNode("", true)
    ])
  ]))
})